import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import EventsList from './EventsList';

const queryClient = new QueryClient();
const PastEventsList = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <EventsList />
    </QueryClientProvider>
  );
};

export default PastEventsList;
